module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo23-43e51006dc8cc9e6b1bc510ab68762f0.jpg";